import * as _ from 'lodash';
import { FOCUS_VIEW } from 'Common/enums';
import { shouldShowReviewConclusions } from 'Selectors';

export const generateChartData = (pivotData: any, focusView: string, reportType: 'value' | 'volume') => {
    let percentageValue;
    const accept = pivotData?.[`MerchantSummary.${reportType}${FOCUS_VIEW.ACCEPT}Transactions`] || 0;
    const reject = pivotData?.[`MerchantSummary.${reportType}${FOCUS_VIEW.REJECT}Transactions`] || 0;
    const review = pivotData?.[`MerchantSummary.${reportType}${FOCUS_VIEW.REVIEW}Transactions`] || 0;
    const all = pivotData?.[`MerchantSummary.${reportType}AllTransactions`];
    const reviewData: PieChartSeriesData = [[FOCUS_VIEW.REVIEW, review]];
    let newSeriesData: PieChartSeriesData = [
        [FOCUS_VIEW.ACCEPT, accept],
        [FOCUS_VIEW.REJECT, reject],
        ...(shouldShowReviewConclusions() ? reviewData : [])
    ];
    let percentageBeforeRounding = 100 * (accept / all);
    if (focusView === FOCUS_VIEW.REJECT) {
        newSeriesData = [
            [FOCUS_VIEW.REJECT, reject],
            [FOCUS_VIEW.ACCEPT, accept],
            ...(shouldShowReviewConclusions() ? reviewData : [])
        ];
        percentageBeforeRounding = 100 * (reject / all);
    } else if (focusView === FOCUS_VIEW.REVIEW) {
        newSeriesData = [
            [FOCUS_VIEW.REVIEW, review],
            [FOCUS_VIEW.ACCEPT, accept],
            [FOCUS_VIEW.REJECT, reject]
        ];
        percentageBeforeRounding = 100 * (review / all);
    }
    if (percentageBeforeRounding < 0.01 && percentageBeforeRounding > 0) {
        percentageValue = '<0.01';
    } else if (percentageBeforeRounding > 99.99 && percentageBeforeRounding < 100) {
        percentageValue = '>99.99';
    } else {
        percentageValue = _.round(percentageBeforeRounding, 2);
    }
    return {
        newSeriesData,
        percentageValue
    };
};
